import { environmentVariables } from 'shared/utils/environment.utils';

// Domain (used for absolute URLs in meta tags and schema)
export const DOMAIN = environmentVariables.wwwUrl;

// Legacy shop
export const LEGACY_SHOP_ROUTE = '/shop';
export const LEGACY_BUSINESS_SHOP_ROUTE = '/business/shop';
export const LEGACY_BUSINESS_SHOP_MOBILE_PHONES_ROUTE = `${LEGACY_BUSINESS_SHOP_ROUTE}/mobile/phones.html`;
export const LEGACY_SHOP_MOBILE_PHONES_ROUTE = `${LEGACY_SHOP_ROUTE}/mobile/phones`;
export const MESSAGE_US = `${LEGACY_SHOP_ROUTE}/message-us`;
export const MOBILE_INSURANCE_PAGE = `${LEGACY_SHOP_ROUTE}/mobile/mobile-insurance`;

// New shop
export const BASE_PATH = environmentVariables.basePath;
export const BUSINESS_PATH = '/business';
export const LARGE_BUSINESS_PATH = '/large-business-govt';
export const AEM_SHOP_ROUTE = '/online/mobile-plans';
export const AEM_BUSINESS_SHOP_ROUTE = `/online${BUSINESS_PATH}/mobile-plans`;
export const BROADBAND_BUY_PLAN = `/broadband/buy-plan/`;

export const GIFT_WITH_PURCHASE = '/gift-with-purchase';
export const ADDONS_PAGE = '/addons';
export const CART_PAGE = '/cart';
export const CHECKOUT_PAGE = '/checkout';
export const FIND_NEAR_ME = '/store-finder';
export const DEVICE_GALLERY_PAGE = '/handsets';
export const PRODUCT_DETAILS_PAGE = '/products';
export const TRADE_IN_PAGE = `${BASE_PATH}/mobile-devices/trade-in`;

// MySpark
export const MOBILE_DETAILS_PAGE = `/secure/myspark/mobiledetails`;

// Website
export const PRIVACY_POLICY_PAGE = '/help/other/terms/policies/privacy-policy';
export const STORE_FINDER_PAGE = '/help/contacts/support/store-finder';
export const LEGACY_SEARCH_PAGE = '/search';

// Journey names
export const BASE_JOURNEY = 'online-shop';
export const MOBILE_BUY_JOURNEY = '/mobile-buy';
export const MOBILE_PLAN_JOURNEY = '/mobile-plan';
export const DEVICE_GALLERY_JOURNEY = '/device-gallery'; // for path section of journey name
export const BROADBAND_BUY_JOURNEY = '/broadband-buy';
export const BROADBAND_CONFIGURATOR_JOURNEY_PAGE = '/broadband-configurator';
export const PRODUCT_DETAILS_JOURNEY_PAGE = '/product-details-page';
